import { render, staticRenderFns } from "./SaibaMais.vue?vue&type=template&id=5182dc91&scoped=true&lang=pug"
import script from "./SaibaMais.vue?vue&type=script&lang=js"
export * from "./SaibaMais.vue?vue&type=script&lang=js"
import style0 from "./SaibaMais.styl?vue&type=style&index=0&id=5182dc91&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5182dc91",
  null
  
)

export default component.exports